export const WIN_MESSAGES = ['Maika‘i!', 'Maika‘i loa', 'Uihā!']
